import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { formatDate } from 'ziphy-web-shared/basic/utils/time';
import { SystemMessage } from '../../../SystemMessage/SystemMessage';
import { ChatMessageClient } from '../../ChatMessageClient';
import styles from './ConsultationCompleteAttachment.module.scss';
export const ConsultationCompleteAttachment = ({ message }) => {
    const attachment = message.attachments.find((el) => el.type === 'consultation_complete');
    const { t } = useTranslation();
    const newMessage = Object.assign(Object.assign({}, message), { attachments: [], content: t('label.consultation_complete') });
    const systemMessage = `${formatDate(attachment.created, 'dateFull')} ${t('label.order_completed')}`;
    return (_jsxs("div", Object.assign({ className: styles.consultationCompleteAttachmentWrapper }, { children: [_jsx(ChatMessageClient, { role: 'provider', message: newMessage, showTimestamp: false }), _jsx(SystemMessage, { message: systemMessage })] })));
};
